import React, { useEffect, useState } from 'react';
import { GeneratingSnackbarProps } from './generating-snackbar.types';
import Snackbar from 'components/snackbar';
import { PAGES } from 'common/enums';
import { GeneratingSnackbarStyledLink } from './generating-snackbar.styled';
import { Text } from 'common/common-components.styled';
import { useHistory } from 'react-router-dom';

const GeneratingSnackbar: React.FC<GeneratingSnackbarProps> = ({ showSnackbar }) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setOpen(showSnackbar);
  }, [showSnackbar]);

  return (
    <Snackbar
      open={open}
      type={'success'}
      time={0}
      message={
        <Text color='darkGreen'>
          Excel-Datei wird generiert, dies kann ggf. einige Minuten in Anspruch nehmen. Sie finden alle exportierten
          Dateien unter "
          <GeneratingSnackbarStyledLink onClick={() => history.push(PAGES.EXPORTS)}>
            {` Exports `}
          </GeneratingSnackbarStyledLink>
          ".
        </Text>
      }
      onClose={() => setOpen(false)}
    />
  );
};

export default GeneratingSnackbar;
